import { AlertDialog, Button, Typography } from '@heroui/react'
import { useBlocker } from '@tanstack/react-router'

export interface ConfirmDiscardDialogProps {
  shouldBlock: boolean
}

export const ConfirmDiscardDialog = ({
  shouldBlock,
}: ConfirmDiscardDialogProps) => {
  const blocker = useBlocker({
    shouldBlockFn: () => shouldBlock,
    withResolver: true,
    enableBeforeUnload: () => shouldBlock,
  })

  return (
    <AlertDialog.Backdrop
      variant="blur"
      isOpen={blocker.status === 'blocked'}
      onOpenChange={open => {
        if (!open) blocker.reset?.()
      }}
    >
      <AlertDialog.Container placement="center">
        <AlertDialog.Dialog className="sm:max-w-[420px]">
          <AlertDialog.Header>
            <AlertDialog.Icon status="warning" />
            <AlertDialog.Heading>Unsaved changes</AlertDialog.Heading>
          </AlertDialog.Header>
          <AlertDialog.Body>
            <Typography.Paragraph>
              Changes you've made will be lost if you leave.
            </Typography.Paragraph>
          </AlertDialog.Body>
          <AlertDialog.Footer>
            <Button slot="close" variant="tertiary">
              Stay
            </Button>
            <Button variant="danger-soft" onPress={() => blocker.proceed?.()}>
              Discard changes
            </Button>
          </AlertDialog.Footer>
        </AlertDialog.Dialog>
      </AlertDialog.Container>
    </AlertDialog.Backdrop>
  )
}
